module.exports = __webpack_public_path__ + "img/fs_14.677bdc2b.jpg";